<template>
  <div class="footer">
    <div class="links">
      <a href="https://api8.iwown.com/4gsdk/#/" title="Iwown 4G Platform Document">平台文档</a>
    </div>
    <div><a href="https://www.flaticon.com/free-stickers/animals" title="animals stickers" style="color:#2284FF">
      Animals stickers created by Stickers - Flaticon</a></div>    
  </div>
</template>

<script>
export default {
  name: "GlobalFooter",
  data() {
    return {};
  }
};
</script>

<style lang="less" src="./index.less" scoped></style>
